import styled from '@emotion/styled';

enum VerticalAlign {
  BaseLine = 'baseline',
  Center = 'center',
  End = 'end',
  Start = 'start',
  Stretch = 'stretch',
}

enum HorizontalAlign {
  Center = 'center',
  End = 'end',
  FlexEnd = 'flex-end',
  FlexStart = 'flex-start',
  SpaceAround = 'space-around',
  SpaceBetween = 'space-between',
  SpaceEvenly = 'space-evenly',
  Start = 'start',
}

enum FlexDirection {
  Column = 'column',
  Row = 'row',
  RowReverse = 'row-reverse',
}

enum FlexWrap {
  NoWrap = 'nowrap',
  Wrap = 'wrap',
  WrapReverse = 'wrap-reverse',
}

interface FlexContainerProps {
  dataPendo?: string;
  flexDirection?: FlexDirection;
  flexWrap?: FlexWrap;
  horizontalAlign?: HorizontalAlign;
  verticalAlign?: VerticalAlign;
}

// TODO: refactor this so we can pass dataPendo as data-pendo to the div
const FlexContainer = styled('div')<FlexContainerProps>`
  display: flex;
  ${(props) => (props.verticalAlign ? `align-items: ${props.verticalAlign};` : '')};
  ${(props) => (props.horizontalAlign ? `justify-content: ${props.horizontalAlign};` : '')};
  ${(props) => (props.flexDirection ? `flex-direction: ${props.flexDirection};` : '')};
  ${(props) => (props.flexWrap ? `flex-wrap: ${props.flexWrap};` : '')};
`;

export default FlexContainer;

export { FlexDirection, HorizontalAlign, VerticalAlign };
